// extracted by mini-css-extract-plugin
export default {"backgroundSection":"BackgroundSection_backgroundSection__JM5qu","container":"BackgroundSection_container__WluFo","titleHome":"BackgroundSection_titleHome__WPmYi"};